import React, { useContext, useEffect, useRef, useState } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { ObservationFormContext } from "../../hooks/ObservationFormContext";
import { AchievementThresholdInputPropsShape } from "../../interfaces/componentTypes";
import { NumericInput } from "./generalUtilities";

export const AchievementThresholdInput: React.FC<AchievementThresholdInputPropsShape> = ({
  handleAchievementThreshold,
  approved,
}) => {
  const { t } = useContext(TMDataContext);
  const { goalState } = useContext(ObservationFormContext);
  let activeId = "goal-threshold-value-input";

  const processInputValue = (value) => {
    let inputScreen = new RegExp(/^[0-9][0-9]?$|^100$/);
    if (!!inputScreen.exec(value) || value == "") {
      handleAchievementThreshold(value);
    }
  };
  return (
    <div
      className="goal-boxed-input-area"
      style={{ display: `${approved ? "block" : "none"}` }}
    >
      <div className="goal-form-input-row">
        <label className="goal-input-area-title" htmlFor={activeId}>
          {t("views.goals.headings.threshold")}
        </label>
        <NumericInput
          id={activeId}
          handleValue={processInputValue}
          state={
            goalState.achievementThreshold == null
              ? ""
              : goalState.achievementThreshold
          }
        />
        <span style={{ marginLeft: "10px", marginRight: "10px" }}>%</span>
      </div>
    </div>
  );
};
